import axios from "axios";
import config from "../config";

export default class VideosService {
  static getVideosForCropByState(cropName, stateCode) {
    const mobile = localStorage.getItem(`mobile`);
    const query = new URLSearchParams(window.location.search);
    const userType = query.get(`source`)?.toLowerCase()?.includes("b2b")
      ? "B2B"
      : "APP";
    return axios.get(
      `${config.agronomyService}/agronomyservice/v1/videos/allcropvideos?cropName=${cropName}&stateCode=${stateCode}&phoneNumber=${mobile}&userType=${userType}`
    );
  }
  static videoActivity(youTubeId, type, phoneNumber) {
    const payload = { youTubeId, type, phoneNumber };
    return axios.post(
      `${config.agronomyService}/agronomyservice/v1/videos/activity`,
      payload
    );
  }
}
